import type { TFunction } from 'i18next'
import { createBasicRule } from '../utils/create-basic-rule.ts'
import type { ValidationRuleFactory } from '../utils/types.ts'
import { invalidStringRule } from './invalid-string.ts'
import { invalidTypeRule } from './invalid-type.ts'
import { tooBigRule } from './too-big.ts'
import { tooSmallRule } from './too-small.ts'

export const defaultRuleFactory: ValidationRuleFactory<'validation'> = (
  t: TFunction<'validation'>
) => [
  createBasicRule('unrecognized_keys', 'unrecognized_keys', t, {
    joinArrays: ', ',
  }),
  createBasicRule('invalid_union', 'invalid_union', t),
  createBasicRule('invalid_enum_value', 'invalid_enum_value', t, {
    joinArrays: ', ',
  }),
  createBasicRule('invalid_arguments', 'invalid_arguments', t),
  createBasicRule('invalid_date', 'date.invalid', t),
  createBasicRule('invalid_return_type', 'invalid_return_type', t),
  invalidTypeRule(t),
  invalidStringRule(t),
  tooSmallRule(t),
  tooBigRule(t),
  createBasicRule('not_multiple_of', 'not_multiple_of', t),
  createBasicRule('invalid_literal', 'invalid_literal', t),
  createBasicRule(
    'invalid_union_discriminator',
    'invalid_union_discriminator',
    t,
    { joinArrays: ', ' }
  ),
  createBasicRule(
    'invalid_intersection_types',
    'invalid_intersection_types',
    t
  ),
  createBasicRule('not_finite', 'not_finite', t),
]
